<template>
  <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
    <v-card>
      <v-card-title>
        <span class="headline">Cambiar de área la orden {{ order.uuid }} </span>
      </v-card-title>
      <v-card-text>
        <v-form ref="changePurchaseOrderArea" v-model="form.valid">
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-select
                  :label="$t('orders.labels.area')"
                  v-model="form.data.area"
                  :items="areas"
                  item-text="name"
                  item-value="id"
                  return-object
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-4"
          outlined
          rounded
          small
          depressed
          @click="closeDialog">
          {{ $t('orders.buttons.close') }}
        </v-btn>
        <v-btn
          data-cy="success"
          color="success"
          class="mr-4"
          rounded
          small
          depressed
          @click="submit">
          {{ $t('orders.buttons.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        valid: false,
        data: {
          area: null
        }
      }
    }
  },
  computed: {
    areas: function () {
      return this.$store.state.currentRestaurant.areas.data || []
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.resetAreaForm()
      }
    }
  },
  methods: {
    submit: async function () {
      this.$refs.changePurchaseOrderArea.validate()

      if (this.form.valid) {
        this.overlay = true
        try {
          const payload = {
            area: this.form.data.area._id
          }
          await this.$api.put(`/v1/orders/${this.order._id}/change-area-order`, payload)
          this.closeDialog()
          this.$toasted.show('La se ha cambiado la orden exitosamente.', { duration: 5000 })
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    resetAreaForm () {
      this.form.data = {
        area: null
      }
    },
    closeDialog () {
      this.isOpen = false
      this.$emit('close', false)
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>
